import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { useAuth } from './context/AuthContext';
import { useEffect } from 'react';

// Pages
import LandingPage from './pages/LandingPage';
import LoginPage from './pages/LoginPage';
import SignupTypePage from './pages/SignupTypePage';
import IndividualSignupPage from './pages/IndividualSignupPage';
import OrganizationSignupPage from './pages/OrganizationSignupPage';
import Dashboard from './pages/Dashboard';
import ClientsPage from './pages/ClientsPage';
import CredentialsPage from './pages/CredentialsPage';
// import PostPreview from './pages/PostPreview';
import PostDetail from './pages/PostDetail';

import './App.css';

// Protected Route Component
const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();

  if (loading) {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '100vh' 
      }}>
        <h2>Loading...</h2>
      </div>
    );
  }

  return isAuthenticated ? children : <Navigate to="/login" />;
};

// Public Route Component (redirect to dashboard if already logged in)
const PublicRoute = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();

  if (loading) {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '100vh' 
      }}>
        <h2>Loading...</h2>
      </div>
    );
  }

  return !isAuthenticated ? children : <Navigate to="/dashboard" />;
};

function App() {
  useEffect(() => {
    const base = (process.env.REACT_APP_S3_IMAGES_BASE || "").replace(/\/$/, "");

    document.documentElement.style.setProperty(
      "--footer-bg",
      `url(${base}/footer-bg.png)`
    );
  }, []);

  return (
    <Router>
      <Routes>
        {/* Public Routes */}
        <Route 
          path="/" 
          element={
            <PublicRoute>
              <LandingPage />
            </PublicRoute>
          } 
        />
        <Route 
          path="/login" 
          element={
            <PublicRoute>
              <LoginPage />
            </PublicRoute>
          } 
        />
        <Route 
          path="/signup" 
          element={
            <PublicRoute>
              <SignupTypePage />
            </PublicRoute>
          } 
        />
        <Route 
          path="/signup/individual" 
          element={
            <PublicRoute>
              <IndividualSignupPage />
            </PublicRoute>
          } 
        />
        <Route 
          path="/signup/organization" 
          element={
            <PublicRoute>
              <OrganizationSignupPage />
            </PublicRoute>
          } 
        />

        {/* Protected Routes */}
        <Route 
          path="/dashboard" 
          element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          } 
        />

        <Route 
          path="/clients" 
          element={
            <ProtectedRoute>
              <ClientsPage />
            </ProtectedRoute>
          } 
        />

        <Route 
          path="/credentials" 
          element={
            <ProtectedRoute>
              <CredentialsPage />
            </ProtectedRoute>
          } 
        />

        <Route path="/posts/:id" element={<ProtectedRoute><PostDetail /></ProtectedRoute>} />


        {/* Catch all - redirect to home */}
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    </Router>
  );
}

export default App;